import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	errorContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100vh',
		padding: spacing.lg,
		textAlign: 'center',
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100vh',
	},
	returnToLoginLink: {
		marginTop: spacing.lg,
		color: colors.primary.main,
	},
	text: {
		marginTop: spacing.lg,
	},
});
